import React from "react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import GridViewIcon from "@mui/icons-material/GridView";

export const SidebarData2 = [
	{
		title: "Profilul Meu",
		path: "/",
		icon: <i class="ri-profile-line"></i>,
	},
     {
		title: "Dosarele Mele",
		path: "/dosarele-mele",
		icon: <i class="ri-file-paper-line"></i>,
	},
];

export const SidebarData = [
     {
          title: <b style={{ color: '#c0392b' }}>Panou Administrator</b>,
          path: "/admin",
          icon: <i className="ri-shield-user-line" style={{ color: '#c0392b', fontSize: 20 }}></i>,
          adminOnly: true,
     },
	{
		title: "Dashboard",
		path: "/",
		icon: <GridViewIcon />,
		iconClosed: <KeyboardArrowRightIcon />,
		iconOpened: <KeyboardArrowDownIcon />,
		colaboratorAllowed: true,
	},
     {
          title: "Chat Intern",
          path: "/chat-intern",
          icon: <i className="ri-chat-private-line" style={{ fontSize: 22 }}></i>,
          colaboratorAllowed: true,
     },
     {
          title: "Clienti",
          path: "/clienti",
          icon: <i class="ri-group-2-line" style={{ fontSize: 22 }}></i>,
          colaboratorAllowed: true,
     },
     {
          title: "Facturare",
          path: "/facturari",
          icon: <i class="ri-money-euro-box-line" style={{ fontSize: 22 }}></i>, 
     },
     {
          title: "Generare Documente",
          path: "/generare",
          icon: <i class="ri-article-line" style={{ fontSize: 22 }}></i>, 
     },
     {
          title: "Academie",
          path: "/academie",
          icon: <i class="ri-book-open-line" style={{ fontSize: 22 }}></i>, 
     },
     {
          title: 'Generare PDF scanat',
          path: "/scanare",
          icon: <i class="ri-scan-2-line" style={{ fontSize: 22 }}></i>,
          colaboratorAllowed: true,
     },
     {
          title: 'Optimizare PDF',
          path: "/optimizare-pdf",
          icon: <i class="ri-refresh-fill" style={{ fontSize: 22 }}></i>,
          colaboratorAllowed: true,
     },
     {
          title: 'Cereri dosare din aplicatie', 
          path: "/cereri-dosare", 
          icon: <i class="ri-smartphone-line" style={{ fontSize: 22 }}></i>, 
     },
     {
          title: 'Cereri suport / consultanta', 
          path: "/cereri-support", 
          icon: <i class="ri-error-warning-line" style={{ fontSize: 22 }}></i>, 
     },
    {
          title: 'QR',
          path: '/qr',
          icon: <i class="ri-qr-code-line" style={{ fontSize: 22 }}></i>,
          colaboratorAllowed: true,
     },
     {
          title: 'Scrisori AI',
          path: '/scrisori',
          icon: <i class="ri-mail-line" style={{ fontSize: 22 }}></i>,
          colaboratorAllowed: true,
     }
];
